import { render, staticRenderFns } from "./VitalSignCrud.vue?vue&type=template&id=cc67082a&"
import script from "./VitalSignCrud.vue?vue&type=script&lang=js&"
export * from "./VitalSignCrud.vue?vue&type=script&lang=js&"
import style0 from "./VitalSignCrud.vue?vue&type=style&index=0&id=cc67082a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports